// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SingleOptionalConsent_wrapper__JB9JY","consentDescription":"SingleOptionalConsent_consentDescription__p8ePF"};